import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
} from "App/constants";
import {
  InputTextMaster,
  MasterButton,
  InputCheckboxMaster,
  Modal,
} from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useState } from "react";
import { defaultToastError, defaultToastSuccess } from "App/utils/helpers";
import { getUserName } from "App/utils/cookies";

export const urlGet = "/wmsMasterAsset/golongan/list_id";
export const urlGetAll = "/wmsMasterAsset/golongan/list";
export const urlUpdate = "/wmsMasterAsset/golongan/update";
export const urlCreate = "/wmsMasterAsset/golongan/add";
export const urlDelete = "/wmsMasterAsset/golongan/delete";

export const RESET_STATE_MASTER_GOLONGAN_BARANG = {
  id: "",
  name: "",
  remark: "-",
  status: true,
};

export const getAllMasterGolonganBarang = async () => {
  try {
    const api = await instance4.get(urlGetAll);
    const res = api.data;
    return res.body;
  } catch (error) {
    defaultToastError(error?.response?.data?.message);
    return false;
  }
};

export const deleteMasterGolonganBarangById = async (id) => {
  try {
    await instance4.post(urlDelete, {
      id,
      user: getUserName(),
    });
    return {
      state: true,
      message: "Data berhasil dihapus",
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "REMARK",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status",
    disablePadding: false,
    label: "Status",
    align: "center",
    minWidth: "120px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "120px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "120px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const ModalForm = ({
  setShowModal,
  formData,
  setFormData,
  setNewData,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const add = async () => {
    return instance4.post(urlCreate, {
      ...formData,
      user: getUserName(),
    });
  };

  const update = () => {
    return instance4.post(urlUpdate, {
      ...formData,
      user: getUserName(),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.name === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          await add();
          defaultToastSuccess("Berhasil menambah golongan barang");
        } else if (formData.id !== "") {
          await update();
          defaultToastSuccess("Berhasil mengubah golongan barang");
        }
        setNewData();
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setFormData(RESET_STATE_MASTER_GOLONGAN_BARANG);
        setShowModal(false);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal
      title={`${
        formData.id === "" ? "Tambah" : "Update"
      } Golongan Barang Fixed Asset`}
      show={setShowModal}
    >
      <form action="POST" onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type="hidden"
            name="id"
            id="id"
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name="name"
              label="INFO"
              id="name"
              value={formData.name}
              onChange={handleChange("name")}
              placeholder="Info"
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name="remark"
              label="REMARK"
              id="remark"
              value={formData.remark}
              onChange={handleChange("remark")}
              placeholder="-"
            />
          </Grid>
          <Grid item sm={12}>
            <div
              style={{
                marginTop: "1.8rem",
              }}
            >
            <label>Status Golongan Barang</label>
              <InputCheckboxMaster
                checked={formData.status}
                name="status"
                id="status"
                label="Aktif"
                onChange={() =>
                  setFormData({ ...formData, status: !formData.status })
                }
              />
            </div>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="submit"
            color={disabled.color}
            name={disabled.label}
            size="md"
          />
        </Grid>
      </form>
    </Modal>
  );
};
